// removed by extract-text-webpack-plugin
module.exports = {"vadpLoginForHXYY_KYYZXJFCXXT":"vadpLoginForHXYY_KYYZXJFCXXT___2kCJ_","pic":"pic___-fIvT","container":"container___LUmdR","logo":"logo___2a3Rp","title":"title___3ywsN","autofill-fix":"autofill-fix___URhf7","vadpLogin":"vadpLogin___1ZPnp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForHXYY_KYYZXJFCXXT/index.less
// module id = 354
// module chunks = 0